<script>
export default {
  name: "ConferenceUser",
  props: {
    conferenceRoomUuid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      filter: {
        email: null,
        conference_room_uuid: null,
      },

      form: {
        id: null,
        email: "",
        first_name: "",
        last_name: "",
        middle_name: "",
        region: "",
        company: "",
        telephone: "",
        email_text:
          "Вы зарегистрированы в системе VRKTPP.ru. " +
          "Добро пожаловать на виртуальную выставку Союза «Калининградская торгово-промышленная палата». " +
          "Это письмо сформировано автоматически.",
      },

      fields: {
        users: [
          {
            key: "user.email",
            label: "Логин (e-mail)",
            class: "align-middle",
          },
          {
            key: "user.last_name",
            label: "Фамилия",
            class: "align-middle",
          },
          {
            key: "user.first_name",
            label: "Имя",
            class: "align-middle",
          },
          {
            key: "user.middle_name",
            label: "Отчество",
            class: "align-middle",
          },
          {
            key: "status",
            label: "Статус",
            class: "align-middle",
          },
          {
            key: "actions",
            label: "Действия",
            class: "actions align-middle text-center",
          },
        ],
      },

      formValidate: {
        email: {
          checkValue: "",
          checkStatus: null,
        },
      },

      busy: {
        conferenceUsers: false,
      },

      conferenceModerator: null,

      errors: {},
    }
  },
  watch: {
    "form.email"(newValue) {
      this.filter.email = newValue
    },
    conferenceModerator(newValue) {
      if (newValue) {
        this.saveStandModerator()
      }
    },
  },
  // TODO: Рефакторить, удалить не нужное!
  computed: {
    getConferenceRoom() {
      return this.$store.getters.getConferenceRoom || {}
    },
    getCurrentConferenceRoomStand() {
      let currentConferenceRoomStand = this.$store.getters.getCurrentConferenceRoomStand
      return currentConferenceRoomStand ?? {}
    },
    getCurrentConferenceRoom() {
      if (this.getCurrentConferenceRoomStand.conference_room) {
        return this.getCurrentConferenceRoomStand.conference_room
      } else return {}
    },
    getConferenceRoomModerator() {
      if (this.getConferenceRoom.moderator) {
        return this.getConferenceRoom.moderator
      } else return {}
    },
    getModerator() {
      const conferenceUser =
        this.getConferenceUsers.find((item) => item.user_id === this.getConferenceRoomModerator.user_id) || {}
      return conferenceUser.user || {}
    },
    getCurrentConferenceUser() {
      if (this.getCurrentConferenceRoomStand.conference_user) {
        return this.getCurrentConferenceRoomStand.conference_user
      } else return {}
    },
    userOptions() {
      return this.$store.getters.getConferenceUsers
    },
    formValidateEmail() {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email)) {
        return true
      } else {
        return false
      }
    },
    formValidateEmailCheckValue() {
      return this.formValidateEmail && this.formValidate.email.checkValue === this.form.email
    },
    busyConferenceUsers() {
      return this.busy.conferenceUsers ? "spin" : null
    },
    formValidateEmailCheckStatus() {
      return this.formValidate.email.checkStatus
    },
    formCheckEmailStatus() {
      return this.formValidateEmailCheckStatus && this.formValidateEmailCheckValue
    },
    getConferenceUsers() {
      return this.$store.getters.getConferenceUsers
    },
    getConferenceUser() {
      return this.$store.getters.getConferenceUser
    },
    getUser() {
      return this.$store.getters.getUser
    },
    getFields() {
      return this.fields.users
    },
    getTitle() {
      return "Участники"
    },
    getTitleForm() {
      if (this.formCheckEmailStatus) {
        return "Добавление существующего пользователя в участники"
      } else {
        return "Добавление нового участника"
      }
    },
    getTitleFormSubmit() {
      if (this.formCheckEmailStatus) {
        return "Обновить и добавить в участники"
      } else {
        return "Создать и добавить в участники"
      }
    },
  },
  methods: {
    selectModerator(conferenceUser) {
      axios
        .patch(`/webapi/conference/room/${this.conferenceRoomUuid}`, {
          conference_user_uuid: conferenceUser.uuid,
        })
        .then(() => {
          this.makeToast("Модератор установлен", "success")
          this.fetchConferenceRooms()
        })
    },
    saveStandModerator() {
      axios
        .post(`/webapi/conference/user`, {
          ...this.form,
          conference_room_uuid: this.conferenceRoomUuid,
        })
        .then(() => {
          this.makeToast("Участник добавлен", "success")
          this.$bvModal.hide("modal-user-form")
          this.fetchConferenceRooms()
          this.fetchConferenceRoomUsers()
          this.fetchConferenceRoomStands()
        })
        .catch(({response}) => {
          this.errors = response.data.errors
          for (const responseKey in this.errors) {
            this.makeToast(this.errors[responseKey][0], "danger")
          }
          if (response.data.message) {
            if (response.data.message !== "The given data was invalid.") {
              this.makeToast(response.data.message, "danger", "Ошибка")
            }
          }
        })
    },
    fetchAll() {
      this.busy.conferenceUsers = true
      Promise.all([
        this.fetchConferenceRooms(),
        this.fetchConferenceStands(),
        this.fetchConferenceRoomUsers(),
        this.fetchConferenceRoomStands(),
      ]).finally(() => {
        this.busy.conferenceUsers = false
      })
    },
    fetchConferenceRooms() {
      return this.$store.dispatch("fetchConferenceRooms")
    },
    fetchConferenceStands() {
      return this.$store.dispatch("fetchConferenceStands")
    },
    fetchConferenceRoomUsers() {
      return this.$store.dispatch("fetchConferenceRoomUsers")
    },
    fetchConferenceRoomStands() {
      return this.$store.dispatch("fetchConferenceRoomStands")
    },
    checkValidateEmail() {
      return false
    },
    checkConferenceUser() {
      this.$store.dispatch("fetchUserByEmail", this.filter).then(() => {
        let user = _.merge({}, this.$store.getters.getUser)
        if (user.id) {
          this.form = _.merge(this.form, user)
          this.formValidate.email.checkStatus = true
          this.formValidate.email.checkValue = user.email
        } else {
          this.form.id = null
          this.formValidate.email.checkStatus = false
          this.formValidate.email.checkValue = this.filter.email
        }
      })
    },
    getStatusName(user) {
      let statusName = ""

      switch (user.status) {
        case "new":
          statusName = "Новый"
          break
        case "activated":
          statusName = "Активирован"
          break
        case "banned":
          statusName = "Заблокирован"
          break
        case "denied":
          statusName = "Отклонён"
          break
      }

      return statusName
    },
    conferenceUserEdit(userId) {
      this.errors = {}
      this.$bvModal.show("modal-user-form")
      axios.get(`/webapi/conference/user/${userId}`).then(({data}) => {
        Object.assign(this.form, data.data)
      })
    },
    conferenceUserAdd() {
      this.form.id = null
      this.formValidate.email.checkStatus = null
      this.formValidate.email.checkValue = ""
      Object.assign(this.form, {
        id: null,
        email: "",
        first_name: "",
        last_name: "",
        middle_name: "",
        region: "",
        company: "",
        telephone: "",
        role: "is_none",
      })
      this.errors = {}
      this.$bvModal.show("modal-user-form")
    },
    conferenceUserSave() {
      axios
        .post(`/webapi/conference/user`, {
          ...this.form,
          conference_room_uuid: this.conferenceRoomUuid,
        })
        .then(() => {
          this.makeToast("Участник добавлен", "success")
          this.$bvModal.hide("modal-user-form")
          this.fetchConferenceRooms()
          this.fetchConferenceRoomUsers()
          this.fetchConferenceRoomStands()
        })
        .catch(({response}) => {
          this.errors = response.data.errors
          for (const responseKey in this.errors) {
            this.makeToast(this.errors[responseKey][0], "danger")
          }
          if (response.data.message) {
            if (response.data.message !== "The given data was invalid.") {
              this.makeToast(response.data.message, "danger", "Ошибка")
            }
          }
        })
    },
    conferenceUserDelete(conferenceUserUuid) {
      this.boxTwo = ""
      this.$bvModal
        .msgBoxConfirm("Действительно удалить участника?", {
          title: "Подтверждение удаления участника",
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Удалить",
          cancelTitle: "Отменить",
          hideHeaderClose: true,
          centered: true,
          bodyClass: "h5",
          titleClass: "font-weight-bold",
          headerClass: "border-bottom-0",
          footerClass: "border-top-0",
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            axios
              .delete(`/webapi/conference/user/${conferenceUserUuid}`)
              .then(() => {
                this.makeToast("Участник удален", "success")
                this.fetchConferenceRooms()
                this.fetchConferenceRoomUsers()
                this.fetchConferenceRoomStands()
              })
              .catch(() => this.makeToast("Ошибка удаления участника", "danger"))
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
    // userPasswordReset(user) {
    //   this.boxTwo = ""
    //   this.$bvModal
    //     .msgBoxConfirm(`На почту ${user.email} будет отправлено уведомление и инструкция для восстановления пароля`, {
    //       title: "Действительно отправить уведомление?",
    //       size: "md",
    //       buttonSize: "md",
    //       okVariant: "primary",
    //       okTitle: "Уведомить",
    //       cancelTitle: "Отменить",
    //       hideHeaderClose: true,
    //       centered: true,
    //       bodyClass: "h5",
    //       titleClass: "font-weight-bold",
    //       headerClass: "border-bottom-0",
    //       footerClass: "border-top-0",
    //     })
    //     .then((value) => {
    //       this.boxTwo = value
    //       if (this.boxTwo) {
    //         axios
    //           .post(`/webapi/user/reset/password`, {
    //             email: user.email,
    //           })
    //           .then(() => {
    //             this.makeToast("Уведомление отправлено", "success")
    //             this.$bvModal.hide("modal-user-form")
    //             this.fetchConferenceRoomUsers()
    //           })
    //           .catch(({ response }) => {
    //             this.errors = response.data.errors
    //           })
    //       }
    //     })
    //     .catch((err) => {
    //       // An error occurred
    //     })
    // },
    makeToast(body = "Ничего не произошло", variant = "warning", title = "Уведомление") {
      this.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 9000,
        appendToast: false,
        variant: variant,
        toaster: "b-toaster-bottom-center",
      })
    },
    userUpdateStatus(userUuid, status) {
      console.warn(userUuid)
      this.boxTwo = ""
      let text_1 = ""
      let text_2 = ""
      let text_3 = ""
      let url = ""
      if (status === "activate") {
        text_1 = "разблокировки"
        text_2 = "разблокировать"
        text_3 = "Разблокировать"
        url = `/webapi/conference/user/${userUuid}/activated`
      } else {
        text_1 = "блокировки"
        text_2 = "заблокировать"
        text_3 = "Заблокировать"
        url = `/webapi/conference/user/${userUuid}/deactivated`
      }

      this.$bvModal
        .msgBoxConfirm(`Действительно ${text_2} пользователя?`, {
          title: `Подтверждение ${text_1} пользователя`,
          size: "md",
          buttonSize: "md",
          okVariant: "primary",
          cancelVariant: "secondary",
          okTitle: text_3,
          cancelTitle: "Отменить",
          hideHeaderClose: true,
          centered: true,
          bodyClass: "h5",
          titleClass: "font-weight-bold",
          headerClass: "border-bottom-0",
          footerClass: "border-top-0",
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            axios.patch(url).then(() => {
              this.fetchConferenceRoomUsers()
            })
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
  },
  created() {
    this.filter.conference_room_uuid = this.conferenceRoomUuid
    // this.fetchConferenceRoomUsers()
  },
}
</script>
